import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";
import {
  urlSynchronizeFarmsSecured,
  urlCenterAllSecured,
  urlAllCentersSecured,
} from "../../api/urls";

const generateFilterAllQuery = ({ filters }) => {
  let filter = "?";
  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.uuid !== undefined) filter += "&uuid=" + filters.uuid;
  }

  return filter;
};

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + 10);

  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};
export const synchronizeData = createAction("SYNCHRONIZE_DATA", (obj, param) =>
  apiPut(urlSynchronizeFarmsSecured, obj, param, true)()
);

/**
 * Filter list Centers.
 */
export const filterCenter = createAction("FILTER_CENTERS", (filter, param) =>
  apiGet(urlCenterAllSecured + generateFilterQuery(filter), param, true)()
);

export const filterAllCenters = createAction(
  "FILTER_CENTERS",
  (filters, param) =>
    apiGet(
      urlAllCentersSecured + generateFilterAllQuery(filters),
      param,
      false
    )()
);

export const allCenters = createAction("FILTER_CENTERS", (filters, param) =>
  apiGet(urlAllCentersSecured, param, false)()
);

// export const getAll = createAction("GET_PERSONS", (filter, param) =>
//   apiGet(urlViewerSecured + generateFilterQuery(filter), param, false)()
// );
